export {fetchUrl, mediaUrl} from "./localConst"

export const routes = {
    app: {
        cs: '/app',
        sk: '/app',
    },
    pdf_offer: {
        cs: '/n',
        sk: '/n',
    },
    hint: {
        cs: '/napoveda',
        sk: '/napoveda',
    },
    dashboard: {
        cs: '/app/dashboard',
        sk: '/app/dashboard',
    },
    login: {
        cs: '/',
        sk: '/',
    },
    ext_login: {
        cs: '/extlogin',
        sk: '/extlogin',
    },
    logout: {
        cs: '/logout',
        sk: '/logout',
    },
    redirect: {
        cs: '/redirect',
        sk: '/redirect',
    },
    changePassword: {
        cs: '/zmena-hesla',
        sk: '/zmena-hesla',
    },
    forgottenPassword: {
        cs: '/zapomenute-heslo',
        sk: '/zabudnute-heslo',
    },
    setPassword: {
        cs: '/nastavit-heslo',
        sk: '/nastavit-heslo',
    },
    user: {
        cs: '/uzivatel',
        sk: '/pouzivatel',
    },
    user_profile: {
        cs: '/uzivatel/profil',
        sk: '/pouzivatel/profil',
    },
    user_credentials: {
        cs: '/uzivatel/sjednatelske-udaje',
        sk: '/pouzivatel/sjednatelske-udaje',
    },
    user_settings: {
        cs: '/uzivatel/nastaveni',
        sk: '/pouzivatel/nastavenia',
    },
    not_found: {
        cs: '/404-stranka-nenalezena',
        sk: '/404-stranka-nenalezena',
    },
    calculation: {
        cs: '/app/kalkulace',
        sk: '/app/kalkulacia',
    },
    calculation_car: {
        cs: '/app/kalkulace/auto',
        sk: '/app/kalkulacia/auto',
    },
    calculation_cest: {
        cs: '/app/kalkulace/cesta',
        sk: '/app/kalkulacia/cesta',
    },
    calculation_maj: {
        cs: '/app/kalkulace/majetek',
        sk: '/app/kalkulacia/majetek',
    },
    calculation_odp: {
        cs: '/app/kalkulace/odpovednost',
        sk: '/app/kalkulacia/zodpovednost',
    },
    calculation_ziv: {
        cs: '/app/kalkulace/zivot',
        sk: '/app/kalkulacia/zivot',
    },
    calculation_pra: {
        cs: '/app/kalkulace/pravni-asistence',
        sk: '/app/kalkulacia/pravni-asistencia',
    },
    settings: {
        cs: '/app/nastaveni',
        sk: '/app/nastavenia',
    },
    settings_companies: {
        cs: '/app/nastaveni/pojistovny',
        sk: '/app/nastavenia/poistovny',
    },
    settings_emails: {
        cs: '/app/nastaveni/emaily',
        sk: '/app/nastavenia/emaily',
    },
    settings_zzjs: {
        cs: '/app/nastaveni/zzj',
        sk: '/app/nastavenia/zzj',
    },
    settings_products: {
        cs: '/app/nastaveni/produkty',
        sk: '/app/nastavenia/produkty',
    },
    settings_productcests: {
        cs: '/app/nastaveni/produkty-cesta',
        sk: '/app/nastavenia/produkty-cesta',
    },
    settings_productmajs: {
        cs: '/app/nastaveni/produkty-maj',
        sk: '/app/nastavenia/produkty-maj',
    },
    settings_productodps: {
        cs: '/app/nastaveni/produkty-odp',
        sk: '/app/nastavenia/produkty-odp',
    },
    settings_predefcombs: {
        cs: '/app/nastaveni/kombinace',
        sk: '/app/nastavenia/kombinacie',
    },
    settings_credentials: {
        cs: '/app/nastaveni/promenne',
        sk: '/app/nastavenia/promenne',
    },
    settings_enums: {
        cs: '/app/nastaveni/ciselniky',
        sk: '/app/nastavenia/ciselniky',
    },
    settings_extccars: {
        cs: '/app/nastaveni/kalk-pripoj',
        sk: '/app/nastavenia/kalk-pripoj',
    },
    settings_extcalcmajs: {
        cs: '/app/nastaveni/kalk-pripoj-maj',
        sk: '/app/nastavenia/kalk-pripoj-maj',
    },
    settings_addinfos: {
        cs: '/app/nastaveni/doplnujici-udaje',
        sk: '/app/nastavenia/doplnujice-udaje',
    },
    settings_carmodels: {
        cs: '/app/nastaveni/modely-vozidel',
        sk: '/app/nastavenia/modely-vozidel',
    },
    settings_carmodelosts: {
        cs: '/app/nastaveni/modely-vozidel-ost',
        sk: '/app/nastavenia/modely-vozidel-ost',
    },
    settings_menufiles: {
        cs: '/app/nastaveni/soubory-menu',
        sk: '/app/nastavenia/soubory-menu',
    },
    settings_zzjsnippets: {
        cs: '/app/nastaveni/zzj-vety',
        sk: '/app/nastavenia/zzj-vety',
    },

    settings_global: {
        cs: '/app/nastaveni-global',
        sk: '/app/nastavenia-global',
    },
    settings_globalmenufiles: {
        cs: '/app/nastaveni/soubory-menu-global',
        sk: '/app/nastavenia/soubory-menu-global',
    },

    users: {
        cs: '/app/uzivatele',
        sk: '/app/pouzivatelia',
    },
    users_users: {
        cs: '/app/uzivatele/uzivatele',
        sk: '/app/pouzivatelia/pouzivatelia',
    },
    users_roles: {
        cs: '/app/uzivatele/role',
        sk: '/app/pouzivatelia/role',
    },
    contracts: {
        cs: '/app/smlouvy',
        sk: '/app/smlouvy',
    },
}


export const toasterDuration = 2500

export const loadDataRefresh = {
    default: 1000 * 60 * 2,
    short: 1000 * 10,
    shortest: 1000 * 2,
    shortestest: 1000,
    none: 10,
    never: 1000 * 60 * 100
}